import { FilterChip } from '@nrg/design-system';
import { useTranslation } from 'react-i18next';
import { LOCALE, type Locale } from '@/modules/topbar/data/types';
import { useLocaleStore } from '@/stores';
import styles from './LanguageChips.module.css';

const OPTIONS: { value: Locale; labelKey: 'topbar.language.nl' | 'topbar.language.en' }[] = [
  { value: LOCALE.Nl, labelKey: 'topbar.language.nl' },
  { value: LOCALE.En, labelKey: 'topbar.language.en' },
];

export function LanguageChips() {
  const { t } = useTranslation();
  const locale = useLocaleStore((s) => s.locale);
  const setLocale = useLocaleStore((s) => s.setLocale);

  return (
    <fieldset className={styles.group}>
      <legend className={styles.legend}>{t('topbar.language.label')}</legend>
      {OPTIONS.map((option) => {
        const pressed = locale === option.value;
        const label = t(option.labelKey);
        return (
          <FilterChip
            key={option.value}
            pressed={pressed}
            aria-label={t('topbar.language.ariaLabel', { language: label })}
            onPressedChange={(next) => {
              if (next && !pressed) {
                setLocale(option.value);
              }
            }}
          >
            {label}
          </FilterChip>
        );
      })}
    </fieldset>
  );
}
